import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useFormContext } from 'react-hook-form'

import { openFoiLetterInNewWindow } from '../../util/openInNewWindow'
import { attachmentStatuses } from '../../util/attachmentConsts'
import { FlexRow, SpaceBetweenRowContainer } from '../styles/Containers'
import { SelectMenuItem } from '../styles/TextField'
import FormSelect from '../inputFields/FormSelect'
import OpenInNewTabButton from '../common/OpenInNewTabButton'
import AttachmentStatus from '../foiAttachments/AttachmentStatus'

const OptionContainer = styled(SpaceBetweenRowContainer)`
  width: 100%;
`

function SelectLetterForm({ foiId, letters = [], letterLabel = '', disabled = false, required = false }) {
  const { watch } = useFormContext()

  const letterId = watch('letterId')

  return (
    <SpaceBetweenRowContainer gap="10px">
      <FormSelect
        key={letterId}
        required={required}
        id="letterId"
        label={letterLabel}
        options={letters}
        defaultValue={letterId || ''}
        disabled={disabled}
        basis="100%"
        minwidth="0">
        <SelectMenuItem value="">None</SelectMenuItem>
        {letters.map(l => (
          <SelectMenuItem key={l.id} value={l.id} component="div">
            <OptionContainer>
              {l.name}
              {l.status && <AttachmentStatus status={l.status} style="small" />}
            </OptionContainer>
          </SelectMenuItem>
        ))}
      </FormSelect>
      <FlexRow padding={letterLabel ? '27px 0 0' : '0'}>
        <OpenInNewTabButton label="View letter in new tab" onClick={() => openFoiLetterInNewWindow(foiId, letterId)} disabled={disabled} />
      </FlexRow>
    </SpaceBetweenRowContainer>
  )
}

SelectLetterForm.propTypes = {
  foiId: PropTypes.string.isRequired,
  letterLabel: PropTypes.string,
  letters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.oneOf(attachmentStatuses)
    })
  ),
  disabled: PropTypes.bool,
  required: PropTypes.bool
}

export default SelectLetterForm
